<template>
  <talentq-test-agree @agree="next" />
</template>

<script>
  import TalentqTestAgree from './components/agree';

  export default {
    name: 'InterviewTalentqAgreeIndex',

    components: {
      TalentqTestAgree
    },

    methods: {
      next() {
        this.$router.push({ name: 'interview-talentq-choice-test', params: this.$router.params });
      }
    }
  };
</script>
